import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

// GET
// /Api/InvoiceVendors/Vendors
export async function getVendorsData(vendorIds = null) {
  const query = new URLSearchParams();
  if (vendorIds != null) vendorIds.forEach((id) => query.append('vendorIds', id));
  const response = await axios.get(`/InvoiceVendors/Vendors?${query.toString()}`);
  return response;
}

// GET
// /Api/InvoiceVendors/BookingTypes
export async function getInvoiceBookingTypes() {
  const response = await axios.get('/InvoiceVendors/BookingTypes');
  return response;
}

// GET
// /Api/InvoiceVendors/ApiVendors
export async function getVendorAPIData(bookingTypeId, refresh = false, signal = null) {
  const response = await axios.get(`/InvoiceVendors/ApiVendors?bookingTypeId=${bookingTypeId}&refresh=${refresh}`, {
    signal,
  });
  return response;
}
// POST
// /Api/InvoiceVendors/ApiVendorsForm
export async function postAPIVendorForm(bookingTypeId, vendorIds) {
  const updatedForm = {
    BookingTypeId: bookingTypeId,
  };
  const formData = objectToFormData({ ...updatedForm });
  if (vendorIds?.length) {
    for (let index = 0; index < vendorIds.length; ++index) {
      formData.append(`VendorIds[${index}]`, vendorIds[index]);
    }
  }
  const response = await axios.post('/InvoiceVendors/ApiVendorsForm', formData);
  return response;
}

// POST
// /Api/InvoiceVendors/VendorForm
export async function postVendorForm(form) {
  const updatedForm = {
    Id: form.id,
    Name: form.name,
    BookingTypeId: form.bookingTypeId?.id ?? 0,
    Code: form.code,
    Subcode: form.subcode,
    EmailTo: form.emailTo,
    Address: form.address,
    Zip: form.zip,
    City: form.city,
    State: form.state,
    Phone: form.phone,
  };
  const formData = objectToFormData({ ...updatedForm });
  const response = await axios.post('/InvoiceVendors/VendorForm', formData);
  return response;
}

// POST
// /Api/InvoiceVendors/DeleteVendors
export async function postDeleteVendors(vendorIds) {
  const formData = objectToFormData({
    vendorIds,
  });
  const response = await axios.post(`/InvoiceVendors/DeleteVendors`, formData);
  return response;
}
